import $ from 'jquery';
// import moment from 'moment';
// import 'daterangepicker/daterangepicker.css';
// import 'daterangepicker';
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
// import 'bootstrap-datepicker';
// import 'bootstrap-timepicker/css/bootstrap-timepicker.css';
// import 'bootstrap-timepicker';
import 'bootstrap-maxlength';
import 'bootstrap-input-spinner';
import 'bootstrap-touchspin';
import 'jquery-mask-plugin';
// import 'select2'; // !!! DO NOT IMPORT THIS, IT WILL OVERWRITE THE CUSTOM SELECT2 CODE
// import 'select2/dist/css/select2.css';
// import 'select2-bootstrap-theme';

export default class AdvancedFormApp {
	constructor() {
		this.$body = $('body');
		this.$window = $(window);
	}

	/**
	 * Initializes the select2
	 */
	initSelect2() {
		// Select2
		// $('[data-toggle="select2"]').select2();
	}

	/**
	 * Initialized mask
	 */
	initMask() {
		$('[data-toggle="input-mask"]').each((idx, obj) => {
			const maskFormat = $(obj).data('maskFormat');
			const reverse = $(obj).data('reverse');
			if (reverse != null) {
				$(obj).mask(maskFormat, { reverse });
			}
			else {
				$(obj).mask(maskFormat);
			}
		});
	}

	// Date-time and date range picker
	initDateRange() {
		// const defaultOptions = {
		// 	cancelClass: 'btn-light',
		// 	applyButtonClasses: 'btn-success',
		// };

		// // date pickers
		// $('[data-toggle="date-picker"]').each((idx, obj) => {
		// 	const objOptions = $.extend({}, defaultOptions, $(obj).data());
		// 	$(obj).daterangepicker(objOptions);
		// });

		// // date pickers ranges only
		// const start = moment().subtract(29, 'days');
		// const end = moment();
		// const defaultRangeOptions = {
		// 	startDate: start,
		// 	endDate: end,
		// 	ranges: {
		// 		'Today': [moment(), moment()],
		// 		'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
		// 		'Last 7 Days': [moment().subtract(6, 'days'), moment()],
		// 		'Last 30 Days': [moment().subtract(29, 'days'), moment()],
		// 		'This Month': [moment().startOf('month'), moment().endOf('month')],
		// 		'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
		// 	},
		// };

		// $('[data-toggle="date-picker-range"]').each((idx, obj) => {
		// 	const objOptions = $.extend({}, defaultRangeOptions, $(obj).data());
		// 	const target = objOptions['targetDisplay'];
		// 	// rendering
		// 	// @ts-ignore
		// 	$(obj).daterangepicker(objOptions, (start, end) => {
		// 		if (target) {
		// 			$(target).html(`${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`);
		// 		}
		// 	});
		// });
	}

	// time picker
	initTimePicker() {
		// const defaultOptions = {
		// 	showSeconds: true,
		// 	icons: {
		// 		up: 'mdi mdi-chevron-up',
		// 		down: 'mdi mdi-chevron-down',
		// 	},
		// };

		// // time picker
		// $('[data-toggle="timepicker"]').each((idx, obj) => {
		// 	const objOptions = $.extend({}, defaultOptions, $(obj).data());
		// 	// @ts-ignore
		// 	$(obj).timepicker(objOptions);
		// });
	}

	// touchspin
	initTouchspin() {
		const defaultOptions = {};

		// touchspin
		$('[data-toggle="touchspin"]').each((idx, obj) => {
			const objOptions = $.extend({}, defaultOptions, $(obj).data());
			$(obj).TouchSpin(objOptions);
		});
	}

	// maxlength
	initMaxlength() {
		const defaultOptions = {
			warningClass: 'badge bg-success',
			limitReachedClass: 'badge bg-danger',
			separator: ' out of ',
			preText: 'You typed ',
			postText: ' chars available.',
			placement: 'bottom',
		};

		// maxlength
		$('[data-toggle="maxlength"]').each((idx, obj) => {
			const objOptions = $.extend({}, defaultOptions, $(obj).data());
			$(obj).maxlength(objOptions);
		});
	}

	/**
	 * Initilize
	 */
	init() {
		this.initSelect2();
		this.initMask();
		this.initDateRange();
		this.initTimePicker();
		this.initTouchspin();
		this.initMaxlength();
	}
}
